// extracted by mini-css-extract-plugin
export default {"blogEntry":"blog-entry__blogEntry--24_Rs"};
    if(module.hot) {
      // 1774528016796
      var cssReload = require("/bento3/bento_cms/static_src/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  